import React from 'react'
import { BoxProps, Flex, Loading, Text } from '@workwhile/ui'

type TableEmptyStateProps = {
  isFetching: boolean
  emptyMessage: React.ReactNode
  emptyStateHeight?: number
  emptyStateMaxWidth?: BoxProps['maxWidth']
}

export function TableEmptyState({
  isFetching,
  emptyMessage,
  emptyStateHeight = 258,
  emptyStateMaxWidth,
}: TableEmptyStateProps) {
  return (
    <Flex
      mb={2}
      flexDirection="column"
      alignItems="center"
      color="lightText"
      height={emptyStateHeight}
      justifyContent="center"
      maxWidth={emptyStateMaxWidth}
      margin={emptyStateMaxWidth ? 'auto' : undefined}
    >
      {isFetching ? <Loading /> : <Text>{emptyMessage}</Text>}
    </Flex>
  )
}
